import React from 'react';


const Footer = () => {

    return (
        <div className="ui grid" style={{ marginTop: '2em', paddingBottom: '1em' }}>
            <div className="sixteen wide right aligned column">
                <h5 className="ui header">
                    <div className="sub header">
                        © José M. Vera 2026, made with <i className="react icon"></i> and <i className="js icon"></i>
                    </div>
                </h5>
            </div>
        </div>
    )
}
export default Footer;